export default __webpack_public_path__ + "static/arun-estates-dark-088d311cff26043013fc0d3e2f9d3ef6.svg";